import React from "react"
import { graphql } from "gatsby"
import { titleTag } from "../utils/headingLevel"
import { PrismicRichText } from "@prismicio/react"
import { Container, Row, Col } from "react-bootstrap"

const hasContent = (field) => Boolean(field?.richText?.length)

export const Pricing = ({ slice, index, slices }) => {
  const Title = titleTag(slices, index)
  if (!slice || !slice.items) {
    return null
  }

  const eyebrow = slice.primary.titles?.text
  const heading = slice.primary.titles_description?.text

  return (
    <section className="pricing-section py-5 py-xl-8">
      <Container>
        <Row className="justify-content-md-center">
          <Col xs={12} md={10} lg={8} xl={7}>
            {eyebrow && (
              <p className="pricing-eyebrow text-center">{eyebrow}</p>
            )}
            {heading && (
              <Title className="pricing-heading text-center">{heading}</Title>
            )}
          </Col>
        </Row>

        <Row className="justify-content-md-center align-items-stretch g-4 mt-2 mt-md-4">
          {slice.items.map((item, index) => {
            const isPopular = item.is_the_main
            const title = item.card_title?.text
            const price = item.card_price?.text
            const ctaLabel = item.card_button_text?.text || "Choose plan"
            const ctaUrl = item.card_url?.url

            return (
              <Col key={index} xs={12} md={6} lg={4} className="d-flex">
                <article
                  className={`pricing-card w-100 d-flex flex-column ${isPopular ? "pricing-card--popular" : ""
                    }`}
                >
                  {isPopular && (
                    <span className="pricing-badge" aria-label="Most popular plan">
                      Most popular
                    </span>
                  )}

                  <header className="pricing-card-head">
                    {title && <h3 className="pricing-card-title">{title}</h3>}
                    {hasContent(item.card_description) && (
                      <div className="pricing-card-description">
                        <PrismicRichText field={item.card_description.richText} />
                      </div>
                    )}
                  </header>

                  <div className="pricing-card-price">
                    {price && (
                      <span className="pricing-card-amount tabular-nums">
                        {price}
                      </span>
                    )}
                    {hasContent(item.price_condition) && (
                      <div className="pricing-card-period">
                        <PrismicRichText field={item.price_condition.richText} />
                      </div>
                    )}
                  </div>

                  {ctaUrl ? (
                    <a
                      href={ctaUrl}
                      className={`btn-st pricing-card-cta ${isPopular ? "" : "btn-st-2"
                        }`}
                    >
                      {ctaLabel}
                    </a>
                  ) : (
                    <button
                      type="button"
                      className={`btn-st pricing-card-cta ${isPopular ? "" : "btn-st-2"
                        }`}
                      disabled
                    >
                      {ctaLabel}
                    </button>
                  )}

                  {hasContent(item.terms) && (
                    <div className="pricing-card-terms">
                      <PrismicRichText field={item.terms.richText} />
                    </div>
                  )}

                  {hasContent(item.extras) && (
                    <div className="pricing-card-extras">
                      <hr className="pricing-card-divider" />
                      <PrismicRichText field={item.extras.richText} />
                    </div>
                  )}
                </article>
              </Col>
            )
          })}
        </Row>
      </Container>
    </section>
  )
}

export const query = graphql`
  fragment PageDataBodyPricing on PrismicPageDataBodyPricing {
    id
    slice_type
    primary {
      titles {
        richText
        text
      }
      titles_description {
        richText
        text
      }
    }
    items {
      card_title {
        richText
        text
      }
      card_description {
        richText
        text
      }
      card_price {
        richText
        text
      }
      price_condition {
        richText
        text
      }
      is_the_main
      card_url {
        url
      }
      card_button_text {
        richText
        text
      }
        terms {
        richText
        text
      }
        extras {
        richText
        text
      }
    }
  }
`;
